import { Component, computed, signal, SimpleChanges } from '@angular/core';
import { CustomWidget } from '../widget';
import { NumberPipe } from '@pipes/number.pipe';
import {
  GetWidgetMetricTypesQuery,
  GetWidgetMetricTypesQueryVariables,
  WidgetMetricType,
} from 'gql/graphql';
import { getWidgetMetricTypesQuery } from '@graphql/dashboard';
import { NgIf } from '@angular/common';
import { TPipe } from '@pipes/t.pipe';

@Component({
  selector: 'abb-kpi-widget',
  standalone: true,
  imports: [NumberPipe, NgIf, TPipe],
  template: `
  <div class="flex items-center gap-4 text-left">
    <span class="text-4xl">
      {{ kpi() | number : { maximumFractionDigits: 2 } }}
    </span>
    <div class="flex flex-col h-full text-xs leading-snug">
      <div *ngIf="metricName()">
        <strong>{{ 'Metric 1' | t }}:</strong> {{ metricName() | t }}
      </div>
      <div *ngIf="metricName()">
        <strong>{{ 'Operation' | t }}:</strong> {{ widget().operation | t }}
      </div>
      <div>
        <strong>{{ otherMetricName() ? ('Metric 2' | t) : ('Constant' | t) }}:</strong>
        {{ otherMetricName() ? (otherMetricName() | t) : (widget().constant ?? '-') }}
      </div>
    </div>
  </div>
`,

  host: {
    class: 'h-full flex justify-center items-center',
  },
})
export class KpiWidgetComponent extends CustomWidget {
  kpi = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'KPIData') {
      return data.kpi;
    }
    return 0;
  });

  private readonly metricTypes = signal<WidgetMetricType[]>([]);

  metricName = computed(() => {
    const id = this.widget()?.metricTypeId;
    return this.metricTypes().find((m) => m.id === id)?.name ?? null;
  });

  otherMetricName = computed(() => {
    const id = this.widget().otherMetricId;
    return this.metricTypes().find((m) => m.id === id)?.name ?? null;
  });

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['widget'] && this.widget()) {
      this.loadMetricTypes();
    }
  }

  private loadMetricTypes() {
    const widget = this.widget();
    if (!widget) return;

    this.apollo
      .watchQuery<GetWidgetMetricTypesQuery, GetWidgetMetricTypesQueryVariables>({
        query: getWidgetMetricTypesQuery,
        variables: {
          categoryId: widget.categoryId,
          // entityId: widget.groupId ?? widget.propertyId ?? widget.deviceId ?? '',
          widgetType: widget.type,
        },
      })
      .valueChanges.subscribe({
        next: ({ data }) => {
          this.metricTypes.set(data.getWidgetMetricTypes ?? []);
        },
        error: (err) => {
          console.error('Error loading metric types', err);
        },
      });
  }
}
